var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 10,
    viewBox: "0 0 42 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 5,
    r: 5,
    fill: "#F2C94C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 5,
    r: 5,
    fill: "#27AE60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActions);
export default __webpack_public_path__ + "static/media/actions.ff2f290e3abf8414338c6808d2990bb7.svg";
export { ForwardRef as ReactComponent };